export function initNav(): void {
  const toggle = document.querySelector<HTMLButtonElement>('.nav-toggle');
  const overlay = document.querySelector<HTMLElement>('.nav-overlay');
  const drawer = document.querySelector<HTMLElement>('.nav-drawer');
  const links = document.querySelectorAll<HTMLAnchorElement>('.nav-drawer__link');

  if (!toggle || !overlay || !drawer) return;

  function open(): void {
    document.documentElement.classList.add('nav-open');
    toggle!.setAttribute('aria-expanded', 'true');
    toggle!.setAttribute('aria-label', 'メニューを閉じる');
    drawer!.removeAttribute('aria-hidden');
    overlay!.removeAttribute('aria-hidden');
  }

  function close(): void {
    document.documentElement.classList.remove('nav-open');
    toggle!.setAttribute('aria-expanded', 'false');
    toggle!.setAttribute('aria-label', 'メニューを開く');
    drawer!.setAttribute('aria-hidden', 'true');
    overlay!.setAttribute('aria-hidden', 'true');
  }

  toggle.addEventListener('click', () => {
    const isOpen = document.documentElement.classList.contains('nav-open');
    isOpen ? close() : open();
  });

  overlay.addEventListener('click', close);

  // ナビリンクをクリックしたらメニューを閉じてスクロール
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      e.preventDefault();
      close();

      // トランジション終了後にスクロール
      const target = document.querySelector<HTMLElement>(href);
      if (!target) return;

      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    });
  });

  // Esc キーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.documentElement.classList.contains('nav-open')) {
      close();
    }
  });
}
